export const QueryKey = {
  GetFavoriteListings: 'FavoriteListings',
  GetListingEnriched: 'ListingEnriched',
  GetSavedSearches: 'SavedSearches',
  GetSimilarListings: 'SimilarListings',
  GetListingsForArea: 'ListingsForArea',
  GetFeedsMarket: 'FeedsMarket',
  GetClientListingFeedsSubscribedDefault: 'GetClientListingFeedsSubscribedDefault',
  GetFeedForZipCode: 'EphemeralFeed',
  GetFeed: 'Feed',
  GetPreferredAgent: 'PreferredAgent',
  GetZipCodeData: 'ZipCodeData',
  AiChat: 'AiChat',
  GetLoanBalance: 'LoanBalance',
  GetMarketInterest: 'Markets',
  GetMarketData: 'MarketData'
}
